import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickCart = (screenName: string) => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_CART',
      analytics: {
        SCREEN: screenName,
        LANDING_FROM: 'CARTICON',
      },
    });
  }, [screenName]);
};
